import React from "react";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";

const UTMLink = (props) => {
  const { to, children, className } = props;
  const utmData = useLocation().search;
  const withHash = /#/.test(to);
  const utmTo = withHash ? `/${utmData}#${to.split("#")[1]}` : to + utmData;
  return (
    <Link to={utmTo} className={className}>
      {children}
    </Link>
  );
};
export default UTMLink;
